import React from 'react'

const OnlineEntrance = () => {
  return (
    <div>OnlineEntrance</div>
  )
}

export default OnlineEntrance